import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";
import React from "react";

export default function ButtonClose({onClose}) {
    return <button
        className="w-7 h-7 flex items-center justify-center cursor-pointer absolute right-4 top-4 outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-inverse focus:ring-primary rounded-full hover:bg-tm-gray-200"
        aria-label="Close"
        onClick={onClose}>
        <XMarkIcon className="w-5 h-5"/>
    </button>
}